import React from 'react';
import { CheckCircle2, MessageSquareText, Send, Target } from 'lucide-react';

const steps = [
	{
		icon: Target,
		title: 'Choose your communities',
		copy: 'Select neighborhoods, apartment buildings, or local areas where your ideal customers live.',
	},
	{
		icon: MessageSquareText,
		title: 'AI answers every lead',
		copy: 'Questions about pricing, timing, and availability are handled instantly with your business context.',
	},
	{
		icon: Send,
		title: 'Campaigns launch automatically',
		copy: 'Promotions and local content are created for the right audience at the right time.',
	},
	{
		icon: CheckCircle2,
		title: 'Jobs land on your schedule',
		copy: 'Qualified customers book directly into your calendar so work starts with less friction.',
	},
];

function ProductDemo() {
	return (
		<section className='landing-section landing-demo' id='demo'>
			<div className='landing-section__intro' data-reveal>
				<p className='landing-eyebrow'>Interactive product story</p>
				<h2>The fastest way for customers to get on your schedule.</h2>
				<p>
					Weciny connects discovery, conversation, marketing, and scheduling in
					one flow built for local service providers.
				</p>
			</div>

			<div className='landing-demo__viewport' data-reveal>
				<div className='landing-demo__track'>
					{steps.map((step) => {
						const Icon = step.icon;
						return (
							<article className='landing-demo__card' key={step.title}>
								<Icon size={26} aria-hidden='true' />
								<h3>{step.title}</h3>
								<p>{step.copy}</p>
							</article>
						);
					})}
				</div>
				<div className='landing-demo__console'>
					<div className='landing-demo__console-top'>
						<span />
						<span />
						<span />
						<strong>AI assistant</strong>
					</div>
					<div className='landing-demo__chat-meta'>
						<span>Wiciny Online</span>
						<span>&lt; 2s response</span>
					</div>
					<div className='landing-demo__chat-tabs'>
						<span>Services</span>
						<span>Pricing</span>
						<span>Hours</span>
						<span>Book now</span>
					</div>

					<div className='landing-demo__chat-thread'>
						<div className='landing-demo__message is-customer' style={{ '--chat-delay': '0.2s' }}>
							Any home cleaning openings near Kensington this Friday?
						</div>
						<div
							className='landing-demo__typing is-ai-typing'
							aria-label='AI is typing'
							style={{ '--chat-delay': '1.2s' }}>
							<span />
							<span />
							<span />
						</div>
						<div className='landing-demo__message is-ai' style={{ '--chat-delay': '2.4s' }}>
							Yes. I found two openings: 10:30 AM and 2:00 PM.
						</div>
						<div className='landing-demo__message is-customer' style={{ '--chat-delay': '3.6s' }}>
							10:30 works. How much for a two-bedroom?
						</div>
						<div
							className='landing-demo__typing is-ai-typing'
							aria-label='AI is typing'
							style={{ '--chat-delay': '4.6s' }}>
							<span />
							<span />
							<span />
						</div>
						<div className='landing-demo__message is-ai' style={{ '--chat-delay': '5.8s' }}>
							It starts at $120. I can reserve Friday at 10:30 AM. What name should I use?
						</div>
						<div className='landing-demo__customer-writing' style={{ '--chat-delay': '7s' }}>
							<span>Customer typing</span>
							<i />
							<i />
							<i />
						</div>
						<div className='landing-demo__message is-customer' style={{ '--chat-delay': '8s' }}>
							Sarah M. Text the confirmation please.
						</div>
					</div>

					<div className='landing-demo__composer'>
						<span>Type a message...</span>
						<button type='button'>Send</button>
					</div>

					<div className='landing-demo__booking' style={{ '--chat-delay': '9s' }}>
						<strong>New Booking</strong>
						<span>Friday 10:30 AM confirmed</span>
					</div>
				</div>
			</div>
		</section>
	);
}

export default ProductDemo;
